"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnvConfigPrototype = exports.NetworkRegion = void 0;
var config_base_1 = require("../config-base");
var NetworkRegion;
(function (NetworkRegion) {
    NetworkRegion[NetworkRegion["GLOBAL"] = 0] = "GLOBAL";
    NetworkRegion[NetworkRegion["EU"] = 1] = "EU";
})(NetworkRegion = exports.NetworkRegion || (exports.NetworkRegion = {}));
var EnvConfigPrototype = /** @class */ (function () {
    function EnvConfigPrototype(regionToAuthSuiteUrl, adobeUrl, isisUrl) {
        this.regionToAuthSuiteUrl = regionToAuthSuiteUrl;
        this.authSuiteUrl = regionToAuthSuiteUrl.get(NetworkRegion.GLOBAL);
        this.adobeUrl = adobeUrl;
        this.isisUrl = isisUrl;
    }
    EnvConfigPrototype.prototype.withRegion = function (region) {
        this.authSuiteUrl = region ? this.resolveAuthSuiteUrl(region) : this.regionToAuthSuiteUrl.get(NetworkRegion.GLOBAL);
        config_base_1.configBase.setConfig(this.build()); // needed for backward compatibility
        return this;
    };
    EnvConfigPrototype.prototype.resolveAuthSuiteUrl = function (region) {
        var url = this.regionToAuthSuiteUrl.get(region);
        return url || this.regionToAuthSuiteUrl.get(NetworkRegion.GLOBAL);
    };
    EnvConfigPrototype.prototype.build = function () {
        return {
            adobeUrl: this.adobeUrl,
            authSuiteUrl: this.authSuiteUrl,
            isisUrl: this.isisUrl,
        };
    };
    return EnvConfigPrototype;
}());
exports.EnvConfigPrototype = EnvConfigPrototype;
